/**
 * The software keyboard inset, measured from the bottom edge of the layout viewport.
 * Present only when the drawer is wrapped in `Drawer.VirtualKeyboardProvider`.
 * @type {CSS length}
 */
export const keyboardInset = '--drawer-keyboard-inset';
